import React, { useState } from 'react';
import { StaticContainer } from '..';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import PhoneIcon from '@material-ui/icons/Phone';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import './Index.css';
import { Link, useHistory } from 'react-router-dom';
import HttpsIcon from '@material-ui/icons/Https';
import { SigninInput } from '../../Components';
const SignUp = () => {
    const hist = useHistory();
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [cpassword, setCPassword] = useState('');

    return (
        <StaticContainer>
            <div className="main-static">
                <h2 className="main-static-heading">Cogminds</h2>
                <h2 className="main-static-subheading">Hi, Welcome</h2>

                <form className="main-static-form" action="submit">
                    <SigninInput
                        label="Username"
                        name="name"
                        Icon={PermIdentityIcon}
                        type="text"
                        value={name}
                        changeHandler={(e) => {
                            setName(e.target.value);
                        }}
                    />
                    <SigninInput
                        label="Phone Number"
                        name="phone"
                        Icon={PhoneIcon}
                        type="phone"
                        value={phone}
                        changeHandler={(e) => {
                            setPhone(e.target.value);
                        }}
                    />
                    <SigninInput
                        label="Email Address"
                        name="email"
                        Icon={MailOutlineIcon}
                        type="email"
                        value={email}
                        changeHandler={(e) => {
                            setEmail(e.target.value);
                        }}
                    />
                    <SigninInput
                        label="Enter Password"
                        name="password"
                        Icon={HttpsIcon}
                        type="password"
                        value={password}
                        changeHandler={(e) => {
                            setPassword(e.target.value);
                        }}
                    />
                    <SigninInput
                        label="Confirm Password"
                        name="password"
                        Icon={HttpsIcon}
                        type="password"
                        value={cpassword}
                        changeHandler={(e) => {
                            setCPassword(e.target.value);
                        }}
                    />

                    <button
                        onClick={() => {
                            hist.push('/');
                        }}
                        className="btn-orange"
                        style={{ fontWeight: '600' }}
                        type="submit"
                    >
                        Signup
                    </button>
                </form>
                <p className="main-static-text">
                    Get Members Benefit. <Link to="/">Login</Link>
                </p>
                <p className="main-static-footer-text">
                    © 2021 powered by Cogminds. Designed and developed by threearrow technologies.{' '}
                </p>
            </div>
        </StaticContainer>
    );
};

export default SignUp;
